export const people = state => state.getIn(['people', 'entities']);
export const personById = (state, id) => people(state).get(String(id));
export const peopleByIds = (state, ids) => ids.map(id => personById(state, id));
